import { useState } from 'react';

const useUbicationAccordion = ({ idStatus = null }) => {
  const [accordionsSelecteds, setAccordionsSelecteds] = useState([]);
  const [accordionsOpens, setAccordionsOpens] = useState([]);
  const [closeAccordions, setCloseAccordions] = useState(false);
  const [modalAddLocation, setModalAddLocation] = useState({
    show: false,
    data: null
  });

  const [modalImputationObject, setModalImputationObject] = useState({
    show: false,
    data: null
  });
  const [showAddPLToUbicationModal, setShowAddPLToUbicationModal] = useState(false);
  const [showFinishedServiceModal, setShowFinishedServiceModal] = useState(false);

  const changeAddPLToUbicationState = (state) => {
    setShowAddPLToUbicationModal(state);
  };

  const isAllAccordionsSelecteds = (a, b) => a?.length === b?.length;

  const isSomeAccordionOpen = () => accordionsOpens?.some((item) => item.isOpen);

  const changeSetAccordionsSelecteds = (ids) => {
    setAccordionsSelecteds(ids);
  };
  const changeSetAccordionsOpens = (ids) => {
    setAccordionsOpens(ids);
  };
  const changeSetModalImputationObject = (obj) => {
    setModalImputationObject(obj);
  };

  // Param dato significa que es el array de la posicion linea o ubicaciones
  const handleSelectAll = (dato) => {
    const idsSeleccionados = dato?.map((item) => item?.id);

    setAccordionsSelecteds(idsSeleccionados);
  };

  const handleUnselectAll = () => {
    setAccordionsSelecteds([]);
  };

  const handleOpenAccordion = (isOpen, accordionId) => {
    setAccordionsOpens(
      accordionsOpens?.map((item) => {
        if (item.id === accordionId) {
          return {
            ...item,
            isOpen
          };
        }

        return item;
      })
    );

    setCloseAccordions(false);
  };

  const closeAllAccordions = () => {
    setAccordionsOpens(
      accordionsOpens?.map((item) => ({
        ...item,
        isOpen: false
      }))
    );
    setCloseAccordions(true);
  };

  const handleOpenModalImputationObject = (ubicationData) => {
    setModalImputationObject({
      show: true,
      data: {
        ...ubicationData,
        statusWorkReportEnum: idStatus
      }
    });
  };

  const handleCloseModalImputationObject = () => {
    setModalImputationObject({
      show: false,
      data: null
    });
  };
  const handleCloseModalAddLocation = () => {
    setModalAddLocation({
      show: false,
      data: null
    });
  };
  const handleOpenModalAddLocation = () => {
    setModalAddLocation({
      show: true,
      data: null
    });
  };
  const handleShowModalFinishedService = () => {
    setShowFinishedServiceModal(!showFinishedServiceModal);
  };

  return {
    accordionsSelecteds,
    handleSelectAll,
    handleUnselectAll,
    changeSetAccordionsSelecteds,
    handleOpenAccordion,
    accordionsOpens,
    changeSetAccordionsOpens,
    closeAccordions,
    closeAllAccordions,
    modalImputationObject,
    handleOpenModalImputationObject,
    handleCloseModalImputationObject,
    changeSetModalImputationObject,
    handleShowModalFinishedService,
    isSomeAccordionOpen,
    isAllAccordionsSelecteds,
    modalAddLocation,
    handleCloseModalAddLocation,
    handleOpenModalAddLocation,
    showAddPLToUbicationModal,
    showFinishedServiceModal,
    changeAddPLToUbicationState
  };
};

export default useUbicationAccordion;
